import { useEffect, useState } from "react";
import { marked } from "marked";
import { adminApi } from "../api.js";
import styles from "../admin.module.css";

interface PageRow {
  slug: string;
  lang: string;
  markdown: string;
}

const SLUGS: Array<{ slug: string; label: string }> = [
  { slug: "imprint", label: "Impressum" },
  { slug: "privacy", label: "Datenschutz" },
  { slug: "credits", label: "Quellen & Credits" },
];

export function Pages() {
  const [pages, setPages] = useState<PageRow[] | null>(null);
  const [slug, setSlug] = useState("imprint");
  const [lang, setLang] = useState<"de" | "en">("de");
  const [markdown, setMarkdown] = useState("");
  const [saved, setSaved] = useState(false);

  function reload() {
    adminApi.get<PageRow[]>("/api/admin/pages").then(setPages);
  }

  useEffect(reload, []);

  useEffect(() => {
    const page = pages?.find((p) => p.slug === slug && p.lang === lang);
    setMarkdown(page?.markdown ?? "");
  }, [pages, slug, lang]);

  async function handleSave() {
    await adminApi.put(`/api/admin/pages/${slug}/${lang}`, { markdown });
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
    reload();
  }

  return (
    <div>
      <h1 className={styles.pageTitle}>Seiten</h1>

      <div className={styles.formRow}>
        <label htmlFor="page-slug">Seite</label>
        <select id="page-slug" className={styles.select} value={slug} onChange={(e) => setSlug(e.target.value)}>
          {SLUGS.map((s) => (
            <option key={s.slug} value={s.slug}>
              {s.label}
            </option>
          ))}
        </select>
      </div>
      <div className={styles.formRow}>
        <label htmlFor="page-lang">Sprache</label>
        <select
          id="page-lang"
          className={styles.select}
          value={lang}
          onChange={(e) => setLang(e.target.value as "de" | "en")}
        >
          <option value="de">Deutsch</option>
          <option value="en">Englisch</option>
        </select>
      </div>

      <div className={styles.card}>
        <h2>Markdown</h2>
        <textarea
          className={`${styles.textarea} ${styles.markdownEditor}`}
          value={markdown}
          onChange={(e) => setMarkdown(e.target.value)}
        />
        <div className={styles.actions}>
          <button type="button" className={styles.button} onClick={handleSave}>
            Speichern
          </button>
          {saved && <span>Gespeichert.</span>}
        </div>
      </div>

      <div className={styles.card}>
        <h2>Vorschau</h2>
        {/* eslint-disable-next-line react/no-danger */}
        <div dangerouslySetInnerHTML={{ __html: marked.parse(markdown, { async: false, breaks: true }) }} />
      </div>
    </div>
  );
}
